export default function NavigateTo(event, link) {
  event.preventDefault();
  window.open(link, "_blank");
};